import React from "react"
import './style.scss'

const arrtop = [
    {img:'https://img.alicdn.com/imgextra/i3/O1CN0188Y4pq1HKxkDt4F1N_!!6000000000740-2-tps-364-128.png',name:'Registration opens'},
    {img:'https://img.alicdn.com/imgextra/i4/O1CN01Lol2y61Q4JtVWMJb3_!!6000000001922-2-tps-480-128.png',name:'Registration deadline'},
    {img:'https://img.alicdn.com/imgextra/i4/O1CN01PwFgFd1oyF1zMV6uA_!!6000000005293-2-tps-364-128.png',name:'Challenge award notification'},
]
const arrbottom = [
    {img:'https://img.alicdn.com/imgextra/i2/O1CN0139it0a1J1qRTR2S6S_!!6000000000969-2-tps-480-128.png',name:'Submission starts'},
    {img:'https://img.alicdn.com/imgextra/i1/O1CN01zHZPyg1UmWaGrzDE6_!!6000000002560-2-tps-480-128.png',name:'Submission deadline'},
    {img:'https://img.alicdn.com/imgextra/i1/O1CN01NOTtKC1ZpnUaIiTLX_!!6000000003244-2-tps-158-128.png',name:'CVPR conference'},
]
const arrs = [
    {img:'https://img.alicdn.com/imgextra/i3/O1CN0188Y4pq1HKxkDt4F1N_!!6000000000740-2-tps-364-128.png',name:'Registration opens'},
    {img:'https://img.alicdn.com/imgextra/i2/O1CN0139it0a1J1qRTR2S6S_!!6000000000969-2-tps-480-128.png',name:'Submission starts'},
    {img:'https://img.alicdn.com/imgextra/i4/O1CN01Lol2y61Q4JtVWMJb3_!!6000000001922-2-tps-480-128.png',name:'Registration deadline'},
    {img:'https://img.alicdn.com/imgextra/i1/O1CN01zHZPyg1UmWaGrzDE6_!!6000000002560-2-tps-480-128.png',name:'Submission deadline'},
    {img:'https://img.alicdn.com/imgextra/i4/O1CN01PwFgFd1oyF1zMV6uA_!!6000000005293-2-tps-364-128.png',name:'Challenge award notification'},
    {img:'https://img.alicdn.com/imgextra/i1/O1CN01NOTtKC1ZpnUaIiTLX_!!6000000003244-2-tps-158-128.png',name:'CVPR conference'},
    
]
export default function Important() {
    return <div className="page-important">
            <div className="important-title">Competition</div>
            <div className className="important-con">
                <div className="important-top">
                    {arrtop.map((item,index) => (
                        <div key={index}>
                            <b/>
                            <img className="noimg" alt="" src={item.img} />
                            <img className="dian" alt="" src="https://img.alicdn.com/imgextra/i3/O1CN018pQwkj29WrHWe9TZJ_!!6000000008076-2-tps-30-44.png" />
                            <span dangerouslySetInnerHTML={{__html:item.name}} />
                        </div>
                    ))}
                </div>
                <div className="important-mu" />
                <div className="important-bottom">
                    {arrbottom.map((item,index) => (
                        <div className={`div${index}`} key={index}>
                            <b/>
                            <img className="noimg" alt="" src={item.img} />
                            <img className="dian" alt="" src="https://img.alicdn.com/imgextra/i3/O1CN018pQwkj29WrHWe9TZJ_!!6000000008076-2-tps-30-44.png" />
                            <span dangerouslySetInnerHTML={{__html:item.name}} />
                        </div>
                    ))}
                </div>
            </div>
            <div className="important-con-mobile">
                {arrs.map((item,index) => {
                    if(index%2){
                        return <div className={`important-bottom important${index}`} key={index}>
                            <div>
                                <b/>
                                <img className="noimg" alt="" src={item.img} />
                                <img className="dian" alt="" src="https://img.alicdn.com/imgextra/i3/O1CN018pQwkj29WrHWe9TZJ_!!6000000008076-2-tps-30-44.png" />
                                <span dangerouslySetInnerHTML={{__html:item.name}} />
                            </div>
                        </div>
                    }else{
                        return <div className={`important-top important${index}`} key={index}>
                        <div>
                            <b/>
                            <img className="noimg" alt="" src={item.img} />
                            <img className="dian" alt="" src="https://img.alicdn.com/imgextra/i3/O1CN018pQwkj29WrHWe9TZJ_!!6000000008076-2-tps-30-44.png" />
                            <span dangerouslySetInnerHTML={{__html:item.name}} />
                        </div>
                    </div> 
                    }
                })}
            </div>
    </div>
}

